import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { useEffect } from "react";
import usePageTitle from "../../../Common/hooks/usePageTitle";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import AdminPackagesGrid from "../components/AdminPackagesGrid/AdminPackagesGrid";
import { useAdminPackages } from "../hooks/useAdminPackages";
import styles from "./AdminPackagesView.module.scss";

const AdminPackagesView = (): JSX.Element => {
    const { fetchData, isLoading, setIsLoading, packages, handleClonePackage } = useAdminPackages();
    usePageTitle("Admin | Packages");

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div id="adminpackages" data-testid="adminpackages" style={{ height: "100%" }}>
            <TopBar>
                <div className={styles.details__topBarContainer}>
                    <Typography variant="h4">Packages</Typography>
                </div>
            </TopBar>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AdminPackagesGrid 
                packages={packages} 
                reloadData={fetchData} 
                setIsLoading={setIsLoading}
                onClonePackage={handleClonePackage}
            />
        </div>
    );
};

export default AdminPackagesView;